// extracted by mini-css-extract-plugin
export var dropdown = "_ta-0";
export var imageWrapper = "_ta-3";
export var itemNameContainer = "_ta-1";
export var productImage = "_ta-2";
export var spinnerWrapper = "_ta-4";